<template>
  <div>
    <m-header></m-header>
    <router-view class="main"></router-view>
    <m-footer></m-footer>
    <!--抛物图片-->
    <transition @after-enter='afterEnter' @before-enter="beforeEnter">
      <!--整张图片-->
      <div class="move_img" v-if="cart.showMoveImg"
           :style="{left:(cart.cartPositionL-20) + 'px',top:(cart.cartPositionT-15) + 'px'}">
        <div><img :src="cart.moveImgUrl"></div>
      </div>
    </transition>
  </div>
</template>
<script>
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  import { mapState, mapMutations } from 'vuex'
  export default {
    data() {
      return {}
    },
    components: {
      MHeader,
      MFooter
    },
    computed: {
      ...mapState(['cart'])
    },
    methods: {
      // 监听图片进入购物车
      listenInCart () {
        this.$store.commit('cart/addanimation',{moveShow: false, receiveInCart: true})
      },
      beforeEnter (el) {
        let elStyle = el.style
        let elChild = el.children[0]
        let elChildSty = elChild.style
        elStyle.transform = `translate3d(0,${this.cart.elTop - this.cart.cartPositionT}px,0)`
        elChildSty.transform = `translate3d(${-(this.cart.cartPositionL - this.cart.elLeft)}px,0,0) scale(1.2)`
      },
      afterEnter (el) {
        let elStyle = el.style
        let elChild = el.children[0]
        let elChildSty = elChild.style
        elStyle.transform = `translate3d(0,0,0)`
        elChildSty.transform = `translate3d(0,0,0) scale(.2)`
        elStyle.transition = 'transform .55s cubic-bezier(.29,.55,.51,1.08)'
        elChildSty.transition = 'transform .55s linear'
        // 动画结束
        elChild.addEventListener('transitionend', () => {
          this.listenInCart()
        })
        elChild.addEventListener('webkitAnimationEnd', () => {
          this.listenInCart()
        })
      }
    },
    mounted() {
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/mixin";

  .main {
    min-height: calc(70vh - 150px);
    background: #ededed;
    overflow: hidden;
    width: 100%;
  }

  .bn {
    border-style: none;
    border-width: 0;
    border: none;
  }

  .move_img {
    position: fixed;
    @include wh(40px);
    width: 45px;
    z-index: 29;
    height: 45px;

    div {
      @extend .bn;
    }

    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
      display: block;
      @extend .bn;
    }
  }

  .quick {
    position: fixed;
    border: 1px solid red;
    width: 60px;
    height: 180px;
    right: 20px;
    bottom: calc(50vh - 90px);
  }
</style>



// WEBPACK FOOTER //
// Index.vue?05d9710c